import React from 'react';
import Banner from '../components/Banner/Banner';
import CoinsTable from '../components/CoinsTable';
import Carousel from '../components/Carousel';

const Homepage = () => {
  return (
    <>
      <Banner />
      <Carousel />
      <CoinsTable />
    </>
  );
};

export default Homepage;
